<template>
<div>
  <div id="wrap">
    <!-- 无数据展示 -->
    <div v-show="noData" class="nodata"><img src="../assets/img//work_list_no_data.png" alt="暂无数据"><span>您目前还没有作品哟</span></div>
    <!-- 分享弹出 -->
    <div v-show="sharestate" class="mask">
      <div class="modal">
        <div class="share_title">分享作品</div>
        <div class="share_name">{{title_value}}</div>
        <div class="close" @click="sharestate = 0">
          <img src="./../assets/img/close_btn.png" alt="关闭">
        </div>
        <div class="qrcode_box">
            <div id="qrcode" ref="qrcode"></div>
            <span>扫码在手机查看作品</span>
        </div>
      </div>
    </div>

    <!-- 所有课程unit -->
    <div class="class_units_list">
      <div class="back" @click="backMain"><img src="../assets/img/back.png" alt=""></div>
      <!-- 单个课程  -->
      <div  v-for="(item, i) in unitData" :key="item._id" v-if="isItemShow(item.startDate,item.type,item.name.zh)" class="class_work">
        <div class="class_work_title">{{item.name.zh}}</div>
        <!-- 作业集合 -->
        <div class="class_work_tasks">

          <!-- scratch1all随堂作业的作业显示 -->
          <!-- 随堂作业一个。循环出多个随堂作业 -->
          <div v-for="(task,index) in item.projects.scratch1all" :key="index"  class="class_work_task">
            <!-- 作业背景展示图片 -->
            <div class="work_task_img" v-bind:style='{"background-image":"url("+task.imageUrl+")"}' >
              <!-- 随堂作品标题 -->
              <div class="task_title"><span class="task_title_position">{{task.title}}</span></div>
            </div>
            <!-- 作业操作卡片 -->
            <div class="task_state" >
              <!-- 未做作业 -->
              <div class="todo" v-show="!task._id">
                <!-- item.courses[0]为 随堂 课程ID，item._id为课程id，task.levelndex为作业顺序号 i第几个课程   levelndex和levelIndex不同-->
                <div class="task_do task_style" @click="task_do(index, i,task.levelndex,'scratch1all')"><div class="task_do_logo task_logo_size"></div><div class="double_view"></div><span>写作业</span></div>
              </div>
              <!-- 作业完成 -->
              <div class="done" v-show="task._id">
                <div class="task_edit  task_style" @click="task_do(index, i,task.levelndex,'scratch1all')"><div class="double_view"></div><div class="task_edit_logo task_logo_size"></div><span>编辑</span></div>
                <div class="task_show  task_style" @click="showTask(task._id)"><div class="double_view"></div><div class="task_show_logo task_logo_size"></div><span>查看</span></div>
                <div class="task_share task_style" @click="createQrcode(task._id,task.title)"><div class="double_view"></div><div class="task_share_logo task_logo_size"></div><span>分享</span></div>
              </div>
            </div>
          </div>

          <!-- 单个作业课后作业task.title为处理作业all增加的一个作业过滤-->
          <div v-show="task.title" v-for="(task,index) in item.projects" :key="index"  class="class_work_task">
            <!-- 作业背景展示图片 -->
            <div class="work_task_img" v-bind:style='{"background-image":"url("+task.imageUrl+")"}' >
              <!-- 作品标题 -->
              <div class="task_title"><span class="task_title_position">{{task.title}}</span></div>
            </div>
            <!-- 作业操作卡片 -->
            <div class="task_state" >
              <!-- 未做作业 -->
              <div class="todo" v-show="!task._id">
                <!-- levelIndex与上task_do 不同 -->
                <div class="task_do task_style" @click="task_do(index, i,task.levelIndex,'scratch2')"><div class="task_do_logo task_logo_size"></div><div class="double_view"></div><span>写作业</span></div>
              </div>
              <!-- 作业完成 -->
              <div class="done" v-show="task._id">
                <div class="task_edit  task_style" @click="task_do(index, i,task.levelIndex,'scratch2')"><div class="double_view"></div><div class="task_edit_logo task_logo_size"></div><span>编辑</span></div>
                <div class="task_show  task_style" @click="showTask(task._id)"><div class="double_view"></div><div class="task_show_logo task_logo_size"></div><span>查看</span></div>
                <div class="task_share task_style" @click="createQrcode(task._id,task.title)"><div class="double_view"></div><div class="task_share_logo task_logo_size"></div><span>分享</span></div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>


</div>
</template>
// <script type='text/javascript' src='http://cdn.staticfile.org/jquery/2.1.1/jquery.min.js'></script>
// <script type="text/javascript" src="http://cdn.staticfile.org/jquery.qrcode/1.0/jquery.qrcode.min.js"></script>
<script>
import Vue from 'vue'
import QRCode from 'qrcodejs2'
import { log } from 'util';

// var ClassWork = {
//   props:['title'],
//   data(){
//     return {

//     }
//   },
//   template:'<div class="class-work" >111{{title}}</div>'
// }
// var wrap=new Vue({
//     el:'#wrap'
// });
export default {
  name:"worklist",
  data(){
    return {
      // 显示无数据图标null默认
      noData:null,
      // 当前时间
      nowDate:null,
      //有几个课程包 去掉先导课程后数量-1
      // aa:"0",
      // 去掉先导课程后数量
      workTitle:'title测试数据',
      show:1,
      unitData:null,
      // packageData:null,
      sharestate:false,
      url:"https://www.baidu.com/",
      // 二维码上标题
      title_value:"",
      nowPackageId: '',
      task_bg:'https://cdn1.geek-8.com/geekmooc/posters/upload_57a28c0993520a5cf010ee15a1000d94.png'

    }
  },
  beforeCreate () {

  },
  mounted () {
    console.log(this.$route.query.nowPackageId, '---------111111');
    this.nowPackageId = this.$route.query.nowPackageId;
    this.getunit();
  },
  methods:{
    // 查看作业按钮跳转
    showTask(task){
      console.log("taskid"+task);
      // 跳转传值
      window.open(window.location.protocol+"//"+window.location.host+"/work#/works?id="+task)
      // 测试环境带work.html
      // window.open(window.location.protocol+window.location.hostname+"/work.html#/works?id="+task)
    },
    // 是否到达课程显示时间 startDate 为接口传输过来的时间 type为课程类型 返回布尔值
    isItemShow(startDate,type,name){
      // 转化为1970 年 1 月 1 日至今的毫秒数 提前两小时显示 -7200000
      var start = new Date(startDate).getTime()-7200000
     
      

        // console.log(start,'显示时间');
        // 当前时间对比开始时间
      if (type==="archived"||type==="scratch/archived") {
        console.log('类型为archived、scratch/archived---课程显示3.26优化去除2小时时间限制');
        //无数据显示nodata图标 null默认值 0只要有数据图标就不显示 1显示无数据
          this.noData = 0
        return true
      }else{
        console.log(name,'----不符合类型条件不显示课程过滤---',type);
        //无数据显示nodata图标 null默认值 0不显示 1显示无数据
        if (this.noData == null) {
          //无数据显示nodata图标 null默认值 0不显示 1显示无数据
          this.noData = 1
        }
        // console.log('类型为',type);
        // console.log(new Date(startDate).getTime(),'showtime',this.nowDate,'nowtime',type);
        return false
      }

    },
    // 做作业 @click="task_do(index, i,task.courses[0],task.levelndex) 0随堂 1课后  
    task_do(index,i,levelndex,scratch_type){
      console.log(index,'index',i,'第'+i+'个课程',this.unitData,"data",levelndex,'levelndex');
      // 课后练习
      if( scratch_type == 'scratch2'){
        
        // 课后作业id
        let courseId = this.unitData[i].courses[1].courseId;
        // 课程id
        let unitId = this.unitData[i]._id;
        // 2.22新增接口参数 levelIndex


        console.log(courseId);
        // window.open(`/package/${this.nowPackageId}/unit/${unitId}/course/${courseId}?level=${levelndex}&type=work`);
        location.href = `/package/${this.nowPackageId}/unit/${unitId}/course/${courseId}?level=${levelndex}&type=work`

      }else{
        // 随堂作业id
        let courseId = this.unitData[i].courses[0].courseId;
        // 课程id
        let unitId = this.unitData[i]._id;
        // 2.22新增接口参数 levelIndex
      
        // console.log(courseId,"courseId",levelndex,'levelndex');
        // window.open(`/package/${this.nowPackageId}/unit/${unitId}/course/${courseId}?level=${levelndex}&type=work`); 
        location.href = (`/package/${this.nowPackageId}/unit/${unitId}/course/${courseId}?level=${levelndex}&type=work`); 
        // console.log("location.href",location.href);
        

      }

//       随堂练习: /package/:packageId/unit/:unitId/course/:courseId?level=last
//     - 课后作业: /package/:packageId/unit/:unitId/course/:courseId



    },
    getunit () {
      this.axios.get(`/v1/api/self/scratch/packages/${this.nowPackageId}`, {
        
      }).then((res) => {


        console.log(res);

        console.log(res.data.package.units.length);
        if (!res.data.package.units.length) {
          console.log("无数据aaaa");
          //无数据显示nodata图标 null默认值 0不显示 1显示无数据
          this.noData = 1

        }else{
          console.log("有数据aaa");

        }
         // 删掉数组第一个元素 去掉无需显示的课程
        // res.data.package.units.shift()

        // this.packageData = res.data.package;
        // console.log(res);

       
        

        this.unitData = res.data.package.units;



        // this.aa = res.data.package.units.length;
        // 几个课程
        console.log('修改后请求到几个课程');
        console.log(res.data.package.units.length);
        console.log(res.data.package.units);

        // console.log(this.unitData.length);
        // return res
        // this.$router.push('/')
        // 获取当前时间
        console.log("获取时间");

        console.log(new Date().getTime());

        this.nowDate = new Date().getTime()
      }).catch((error) => {
        if (error.response) {
          // 失败
          this.$message.error('账号密码错误')
          let data = error.response.data
          this.errorMessage = data.error.message
        }
      })
    },
    backMain () {
      this.$router.push({path:'/', query:{'packageId': this.nowPackageId}});
    },
    createQrcode (task,tasktitle_value) {
      console.log("");
      let qrtext = `${location.origin}/portkey/scratchprojects/${task}`;
      // 获取分享标题当前名称 赋值
        this.title_value = tasktitle_value
        this.sharestate = 1
        document.getElementById('qrcode').innerHTML = ''
        let qrcode = new QRCode('qrcode', {
            // text: this.url,
            // 部署环境不能使用work.html
            // 21/1/5 微信身份扫码地址变更
            // text:window.location.protocol+"//"+window.location.host+"/work#/works?id="+task,
            text:qrtext,// 21/1/5 微信身份扫码地址变更
            // 测试环境带work.html
            // text:window.location.protocol+"//"+window.location.host+"/work.html#/works?id="+task,
            width: 145, //图像宽度
            height: 145, //图像高度
            colorDark : "#000000", //前景色
            colorLight : "#ffffff", //背景色
            typeNumber:4,
            correctLevel : QRCode.CorrectLevel.H //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
        })
        // qrcode.clear() //清除二维码
        // qrcode.makeCode(url) //生成另一个新的二维码
    }






  },

  computed:{


    // createQrcode(){
    //   this.sharestate = 1
    //   jQuery('#qrcode').qrcode({ width: 145, height: 145, text: window.location.href });
    // }

  }
}

</script>


<style lang="stylus" scoped>
// 外部容器 背景
#wrap{
  background:#E5FFED
  // background-image: url(../assets/img/bgtest.png)
  // background:url(../assets/img/bgtest.png) left top no-repeat;
  background-size: 100% 100%;
  min-height 100vh
  height 100%
  // overflow hidden
  display flex
  overflow hidden
  // 最小宽度
  min-width 1024px
  // 分享界面 背景遮罩
  .mask{
	position: fixed;
	width: 100%;
	height: 100%;
	min-height: 100vh;
	left: 0;
	top: 0;
	background: rgba(0,0,0,.5);
	display: flex;
	align-items: center;
	justify-content: center;
  z-index 100
  }
  // 分享弹窗 
  .mask .modal{
    position absolute
    width: 528px;
    height: 356px;
    background-image: url(../assets/img/share_view.png)
    background-size: 100% 100%;
    // 关闭弹窗按钮
    .close{
      position:absolute
      width 62px
      height 62px
      // background #000
      top -26px
      left 487px
      img{
        width 62px
        height 62px
      }
    }
    // 分享弹窗title
    .share_title{
      font-size:26px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(253,169,10,1);
      line-height:37px;
      position absolute
      top 38px
      left 211px
    }
    // 分享作品名称
      .share_name{
        width 528px
        font-size:16px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(94,94,94,1);
        line-height:22px;
        position absolute
        top 82px

        text-align center
        // left 216px

      }
    // 分享弹窗中二维码
    .qrcode_box{
      width:165px;
      height:190px;
      background:rgba(255,255,255,1);
      box-shadow:0px 0px 9px 0px rgba(255,156,6,0.5);
      border-radius:8px;
      border:3px solid rgba(254,186,40,1);
      position absolute
      top 130px
      left 181px
      text-align center
      #qrcode{
        width 145px
        height 145px
        background #000
        margin 10px
      }
       span{
        // height:18px;
        font-size:13px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(94,94,94,1);
        line-height:18px;
        width 100%
        // position absolute
        // left 23px
        text-align center
      }

    }
  }
  .back{
    z-index 999
    cursor:pointer;
    position fixed
    left 54px
    top 35px
    width 46px
    height 34px
    // width 4vw
    // height 3vw
    img{
      width 46px
      height 34px
      // width 4vw
      // height 3vw
      
    }
  }

}
// 课程列表容器 容纳课程
.class_units_list{
  margin 0 auto 50px
  // align-self center
  position relative
  margin-top 27px
  
}
// 单个课程
.class_work{
  margin 0 auto
  // 一行三个
  // width:830px; 
  // 一行四个？963
  width:967px;
  min-height:294px;
  background:rgba(133,228,255,1);
  border-radius:13px;
  position relative
  border:7px solid rgba(133,228,255,1);
  margin-top 13px
  // 鼠标悬浮课程 改变背景
  &:hover{
    background:rgba(255,255,255,1);
    // border:5px solid #00AEE1
    box-shadow:0px 1px 13px 0px rgba(27,148,239,0.85);
    border-radius:13px;
    // box-sizing: border-box;
  }
  // 鼠标悬浮课程改变 标题颜色
  &:hover .class_work_title{
      color:rgba(0,174,225,1);
    }
  // 课程标题样式
  .class_work_title{
    font-size:24px;
    font-family:PingFangSC-Semibold,PingFang SC;
    font-weight:600;
    // color:rgba(0,174,225,1);
    color:rgba(255,255,255,1);
    line-height:33px;
    position absolute
    left 30px
    top 18px
  }
    // 作业集合
  .class_work_tasks{
    padding-top 66px
    // margin-left 28px 为了左右间距一致
    margin-left 30px
    border-radius:14px;
    // 测试背景
    // background green


  }
  // 单个课程内单作业task
  .class_work_task{
    // border-radius原来16
    border-radius:14px;
    overflow hidden
    position relative
    top 0
    left 0
    // width:217px;
    // height:217px;
    // 三个变四个作业
    width:204px;
    height:204px;
    // background :rgba(0,0,0,0.6);
    // background :rgb(0,0,0);
    margin-right 30px
    margin-bottom 20px
    display inline-block
    // 作业操作卡片（写作业 编辑 查看 分享） 默认隐藏

    .task_state{
      width:204px;
      height:204px;
      position:absolute
      // 隐藏操作卡
      // display:none
      visibility:hidden
      // background #654286
      background:#000;
      // opacity: 0.8;

      // 作业小logo 通用
      .task_logo_size{
        width 22px
        height 22px
        position absolute
        left 42px
        top 13px
        background-size:22px 22px;
        background-repeat:no-repeat;
        z-index 10

        // background green
      }
      // 做作业
      .task_do{
        position absolute
        left 22px
        top 82px
        &:hover {
          top 85px
        }
        // 做作业按钮logo
        .task_do_logo{
          background-image: url(../assets/img/task_do_y.png);
          // width 22px
          // height 22px
        }
        // 做作业按钮logo 鼠标悬浮变色
        &:hover .task_do_logo{
          background-image: url(../assets/img/task_do_w.png);

        }

      }
      .task_edit{
        position absolute
        left 22px
        top 22px
        &:hover {
          top 25px
        }
        // 编辑按钮logo
        .task_edit_logo{
          background-image: url(../assets/img/task_edit_y.png);
          // width 22px
          // height 22px
        }
        // 按钮logo 鼠标悬浮变色
        &:hover .task_edit_logo{
          background-image: url(../assets/img/task_edit_w.png);

        }
      }
      .task_show{
        position absolute
        left 22px
        top 81px
        &:hover {
          top 84px
        }
        // 按钮logo
        .task_show_logo{
          background-image: url(../assets/img/task_show_y.png);
          // width 22px
          // height 22px
        }
        // 按钮logo 鼠标悬浮变色
        &:hover .task_show_logo{
          background-image: url(../assets/img/task_show_w.png);

        }
      }
      .task_share{
        position absolute
        left 22px
        top 140px
        &:hover {
          top 143px
        }
        // 按钮logo
        .task_share_logo{
          background-image: url(../assets/img/task_share_y.png);
          // width 22px
          // height 22px
        }
        // 做作业按钮logo 鼠标悬浮变色
        &:hover .task_share_logo{
          background-image: url(../assets/img/task_share_w.png);

        }
      }

      // 作业按钮通用样式
      .task_style{
        cursor:pointer;
        position absolute
        // left 23px
        // top 87px
        width:161px;
        height:45px;
        background:rgba(255,255,255,1);

        border-radius:24px;
        font-size:20px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(253,185,39,1);
        line-height:28px;
        // z-index 9
        // 作业按钮鼠标悬浮修改背景颜色文字颜色
        &:hover {
          background:linear-gradient(118deg,rgba(255,166,60,1) 0%,rgba(211,135,0,1) 100%);
          color:rgba(255,255,255,1);
          z-index 9
          // 鼠标hover图片位置修正
          .task_logo_size{
            position absolute
            // left 42px
            // top 13px
            // 修正3像素
            top 10px
          }
          // 鼠标悬浮重影
          .double_view{
            width:161px;
            height:45px;
            background:linear-gradient(135deg,rgba(255,220,75,1) 0%,rgba(253,182,36,1) 100%);

            border-radius:24px;
            position absolute
            top -3px
          z-index 5
          }
          // 文字位置调整 3
          span{
            // top 11px
            top 8px
          }


        }
        // tak文字位置
        span{
          position:absolute
          left 76px
          top 11px
          z-index 10
        }
      }
    }

    // task作业背景 217换204
    .work_task_img{
      width 204px
      height 204px
      background green
      position absolute
      top 0
      left 0
      background-size 204px 204px
      // 默认显示
      visibility:visible
      overflow hidden

      .task_title{
        width:204px;
        height:39px;
        background:rgba(254,216,71,1);
        // font-size:20px;
        font-size:17px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:39px;
        position absolute
        top 165px
        left 0

        .task_title_position{
          position absolute
          left 20px
        }
      }
    }

    // // 鼠标移入作业 隐藏显示操作卡片
    &:hover .task_state{
      visibility:visible
      background:rgba(0,0,0,0.6);
    }
    // 鼠标移入作业
    &:hover  .task_title{
      // 操作让卡片显示 文字隐藏
      visibility:hidden
    }

  }


}
// 无数据提示展示提示
.nodata{
  position absolute
  top 19vw
  left 36vw
  img{
    width 342px
    height 137px
  }
  span{
    position absolute
    left 137px
    top 57px
    font-size:17px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(255,143,0,1);
    line-height:24px;
  }
}

</style>
